import { useState } from "react";
import CourseSection from "../components/ui/CourseSection";
import { AnimatePresence, motion } from "framer-motion";
import headerImage from "../assets/Picture1.webp";
import { cn } from "@/lib/utils";
import ImageHeading from "../components/ui/ImageHeading";

import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";
import { transformCourseData } from "../utils/courseFormatter";

const CourseCatalog = () => {
  const [active, setActive] = useState("0");
  const axiosPublic = useAxiosPublic();

  const {
    data: courseData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["course"],
    queryFn: async () => {
      const res = await axiosPublic.get("/academics/course-catalog");
      return res?.data?.data;
    },
  });
  console.log(courseData, "course data");
  // Transform the data
  const transformedTabData = courseData ? transformCourseData(courseData) : {};

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200">
      <ImageHeading heading="Course Catalog" imageUrl={headerImage} />
      <div className="container mx-auto py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
        {/* Tabs */}
        <div
          className={cn(
            "mb-8 flex flex-row items-center justify-center overflow-scroll [perspective:1000px] relative sm:overflow-visible h-full no-visible-scrollbar max-w-full w-full",
          )}
        >
          <div className="px-8 py-4 bg-white rounded-md shadow-xl lg:rounded-full w-fit">
            {Object.entries(transformedTabData).map(([key, value]) => (
              <button
                key={key}
                onClick={() => {
                  setActive(key);
                }}
                className={cn("relative px-4 py-2 rounded-full")}
                style={{
                  transformStyle: "preserve-3d",
                }}
              >
                {active === key && (
                  <motion.div
                    layoutId="clickedbutton"
                    transition={{ type: "spring", bounce: 0.3, duration: 0.6 }}
                    className={cn(
                      "absolute inset-0 bg-primary text-white rounded-full",
                    )}
                  />
                )}

                <span
                  className={`relative block ${
                    active === key ? "text-white" : "text-black"
                  }`}
                >
                  {value.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            className="bg-white/80 backdrop-blur-sm rounded-xl shadow-xl overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            {transformedTabData[active]?.sections.map((section, index) => (
              <motion.div
                key={section.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <CourseSection
                  title={section.title}
                  subtitles={section.subtitles}
                  courses={section.courses}
                />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CourseCatalog;
